import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';

export default class TKCompareSelect extends TKCustomElementFactory {
    postURL: string;
    targetDiv: string;
    fieldElement?: HTMLSelectElement;
    wrapper?: HTMLElement;

    constructor() {
        super();

        this.fieldElement = this.querySelector('select') || undefined;
        this.postURL = this.getAttribute('data-tk-compare-post-url') || window.location.href;
        this.targetDiv = this.getAttribute('data-tk-compare-target-div') || '[data-tk-compare-wrapper]';
        this.wrapper = document.querySelector('[data-tk-compare-wrapper]') || undefined;
    }

    connectedCallback(): void {
        if (!this.fieldElement || !this.wrapper) throw new Error('Compare: Elements are missing!');
        this.registerInputListener();
    }

    registerInputListener() {
        const onInput = this.fetch.bind(this);
        this.pushListener({ event: 'input', element: this.fieldElement!, action: onInput });
    }

    fetch(event: InputEvent) {
        const target = event.currentTarget as HTMLSelectElement;
        const selectedItem = target.options.item(target.selectedIndex);
        if (!selectedItem) return;
        const data: Record<string, string> = {
            ArtCompareType: selectedItem.value,
            Target: this.targetDiv,
        };

        fetchRequest({
            requestURL: this.postURL,
            resolveHandler: this.refreshContent.bind(this),
            payload: data,
        });
    }

    refreshContent(response: TKResponse) {
        if (!response || !response.success) return;
        const html = render(response.dataAsHtml);
        const targetWrapper = html.querySelector('[data-tk-compare-wrapper]');
        if (!targetWrapper) return;
        this.wrapper!.innerHTML = targetWrapper.innerHTML;
    }
}
